import React from 'react';
import { Formik } from 'formik';
import { Icon } from 'semantic-ui-react';
import { ButtonContainer, FormInput, FormField, SubmitButton, Spinner } from '../../styles';
import { Button } from '../../../Shared/styles';
import schema from '../../validationSchema';
import Error from '../../Error';
import './styles.css';
import { NeutralLabel } from './styles';
import { NimlyApplicationId } from '../../../../../utils/applications';

export default ({
  isNewPasswordVisible,
  isConfirmPasswordVisible,
  onToggleVisibility,
  onSubmit,
  companyId,
}) => (
  <Formik
    validationSchema={schema}
    onSubmit={onSubmit}
    initialValues={{ newPassword: '', confirmPassword: '' }}
    render={({
      values,
      errors,
      touched,
      handleBlur,
      handleChange,
      handleSubmit,
      isValid,
      resetForm,
      isSubmitting,
    }) => (
      <form onSubmit={handleSubmit}>
        <FormField>
          <NeutralLabel>New password*</NeutralLabel>
          <FormInput
            type={isNewPasswordVisible ? 'text' : 'password'}
            name="newPassword"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.newPassword}
            placeholder="New password"
            icon={
              <Icon name="eye" link onClick={() => onToggleVisibility('isNewPasswordVisible')} />
            }
          />
          {errors.newPassword && touched.newPassword && <Error message={errors.newPassword} />}
        </FormField>
        <FormField>
          <NeutralLabel>Re-new password*</NeutralLabel>
          <FormInput
            type={isConfirmPasswordVisible ? 'text' : 'password'}
            name="confirmPassword"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.confirmPassword}
            placeholder="Re-new password"
            icon={
              <Icon
                name="eye"
                link
                onClick={() => onToggleVisibility('isConfirmPasswordVisible')}
              />
            }
          />
          {errors.confirmPassword && touched.confirmPassword && (
            <Error message={errors.confirmPassword} />
          )}
        </FormField>
        <ButtonContainer>
          <Button type="button" onClick={() => resetForm()}>
            Reset form
          </Button>
          <SubmitButton>
            <Button
              submit
              type="submit"
              disable={!isValid || isSubmitting}
              background={companyId === NimlyApplicationId ? '#4bbb56' : '#2ec9ad'}
            >
              Confirm
            </Button>
            {isSubmitting ? <Spinner name="circle notch" loading /> : null}
          </SubmitButton>
        </ButtonContainer>
      </form>
    )}
  />
);
